import React from 'react';
import { useForm, FormProvider } from 'react-hook-form';
// lodash
import _ from 'lodash';

// components
import { Box, Typography } from '@mui/material';
import { P100SecurityQuestionsSchema } from './_validations/DefaultAccountValidations';
import { AccountFieldsContainer } from './profile/AccountFieldsContainer';
import { P100SecurityQuestionsFields } from './fields/P100SecurityQuestionsFields';
// hooks
import { useSingleFormValidationResolver } from '../hooks';

const defaultValuesKeys = [
  'isSecurityOfficer',
  'isSecurityTraining',
  'claimHistory',
  'useEncryption',
  'useCloudStorage',
];

const initialDefaultValue = {
  isSecurityOfficer: null,
  isSecurityTraining: null,
  claimHistory: null,
  useEncryption: null,
  useCloudStorage: null,
};

const AccountP100SecurityQuestionsForm = ({
  formId = 'P100SecQuestions',
  formName = 'Security Assessment',
  handleOnSubmit,
  defaultValues = initialDefaultValue,
  validationSchema = P100SecurityQuestionsSchema,
  children,
  reportErrors,
  registerForm = () => null,
  disabled = false,
  FieldsContainer = AccountFieldsContainer,
}: any) => {
  const resolver = useSingleFormValidationResolver(validationSchema, {
    formId,
    formName,
    reporter: reportErrors,
  });

  const { handleSubmit, ...methods } = useForm({
    defaultValues: _.pick(defaultValues, defaultValuesKeys),
    resolver,
  });

  function onSubmit(values: any) {
    return handleOnSubmit(values).then((finalValues: any) => {
      const nextValues = finalValues || values;
      methods.reset({ ...nextValues });
    });
  }

  React.useEffect(() => {
    registerForm({
      id: formId,
      name: formName,
      handler: handleSubmit(onSubmit),
      reset: methods.reset,
    });
    // eslint-disable-next-line
  }, []);

  return (
    // @ts-expect-error TS(2741): Property 'handleSubmit' is missing in type '{ chil... Remove this comment to see the full error message
    <FormProvider {...methods}>
      <form id={formId} onSubmit={handleSubmit(onSubmit)}>
        {typeof children === 'function' ? (
          children()
        ) : (
          <>
            <Box display="flex" justifyContent="space-between">
              <Typography
                variant="h3"
                className="primer-text contrast-text"
                paragraph
              >
                {formName}
              </Typography>
            </Box>
            <FieldsContainer>
              <P100SecurityQuestionsFields disabled={disabled} />
            </FieldsContainer>
          </>
        )}
      </form>
    </FormProvider>
  );
};

export default AccountP100SecurityQuestionsForm;
